import styled from 'styled-components'

export const AppWrapper = styled.div`
  display: flex;
  height: calc(100vh - 85px);
  z-index: 0;
`
export const MainContent = styled.main`
  overflow-y: auto;
  height: 100%;
  width: 100%;
  padding-left: 96px;
  padding-right: 96px;
`
